/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-19 15:36:16                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 17:32:09                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Avatar: avatar component, display user avatar
    * useEffect - set no img avatar size
*/

/* Imports */
import { Avatar as A, Tooltip } from "@material-tailwind/react";
import { useEffect, useState } from "react";
/***/

/**
* Avatar: avatar component, display user avatar 
* @param img - if set, display profile image
* @param name - profile name, used to display no img avatar
* @param color - profile color
* @param size - avatar size
*/
export default function Avatar({
  img,
  name,
  color,
  size = "sm"
}: {
  img?: string,
  name: string,
  color?: string,
  size?: "sm" | "md" | "lg"
}) {
  const [noImgSize, setNoImgSize] = useState<number>(0);

  /**
  * useEffect - set no img avatar size
  * manage no img avatar size based on size prop
  */
  useEffect(() => {
    if (size === "sm") setNoImgSize(9);
    if (size === "md") setNoImgSize(12);
    if (size === "lg") setNoImgSize(16);
  }, [size]);
  /***/

  return (
    <Tooltip content={name} placement="left">
      {img ?
        <A  variant="circular"
            size={size}
            alt="tania andrew"
            className="border border-gray-900 p-0.5"
            src={img}/>
      : 
        <div  className={`no-img-avatar rounded-full flex-shrink-0 w-${noImgSize} h-${noImgSize} flex items-center justify-center text-lg`}
              style={{backgroundColor: color || "silver"}}>
          {name.substring(0, 1)}
        </div>
      }
    </Tooltip>
  );
}
/***/
